import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { App } from '@capacitor/app';
import { AlertController } from '@ionic/angular';
import { CurrentPlatformService } from '../current-platform/current-platform.service';
import { AppUpdate } from '@robingenz/capacitor-app-update';
import { StorageService } from '../storage/storage.service';
import { storageKeys } from 'src/app/enum/storage-keys';



// interface AppUpdate{
//   current: string,
//   enabled: string, 1 -> true / 0 -> false
//   msg?: { // for mantanence
//     title: string,
//     msg: string,
//     btn: string
//   };
//   majorMsg?: { // major update 1.5.0 -> 2.5.0
//     title: string,
//     msg: string,
//     btn: string
//   };
//   minorMsg?: { // minor update 1.5.0 -> 1.6.0
//     title: string,
//     msg: string,
//     btn: string
//   }
// }

@Injectable({
  providedIn: 'root'
})
export class UpdateService {

  _mainerUpdate: boolean = false;
  _mainerMsg: any = null

  constructor(
    private http: HttpClient,
    private alertCtrl: AlertController,
    private currentPlatformService: CurrentPlatformService,
    private storageService: StorageService
  ) { }

  async checkForUpdate() {

    try {
      if (this.currentPlatformService.isNative()) {
        const appInfo = await this.getUpdateFromDB();
        console.log(appInfo);

        if (appInfo.enabled == '0') { // maintenance
          this.presentAlert(appInfo.msg.title, appInfo.msg.msg)
        } else { // chick version

          const versionNumber = (await App.getInfo()).version;
          const splittedVersion = versionNumber.split('.');
          const severVersion = appInfo.current.split('.');
          const mainerUpdate = await this.storageService.getStorage(storageKeys.MAINERUPDATE);
          console.log('mainerUpdate', mainerUpdate.value);

          if (severVersion[0] > splittedVersion[0]) { // majer
            this.presentAlert(appInfo.majormsg.title, appInfo.majormsg.msg, appInfo.majormsg.btn);
          } else if (severVersion[1] > splittedVersion[1]) { //mainer
            this._mainerUpdate = true;
            this._mainerMsg = appInfo.minormsg;
            if(!(mainerUpdate && mainerUpdate.value)){
              await this.storageService.setStorage(storageKeys.MAINERUPDATE, JSON.stringify(true));
              this.presentAlert(appInfo.minormsg.title, appInfo.minormsg.msg, appInfo.minormsg.btn, true);
            }
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  async openAppstoreEntry() {
    await AppUpdate.openAppStore();
  }

  async presentAlert(header, message, btn = '', allowCloser = false) {
    const buttons: any = [];

    if (btn != '') {
      buttons.push({
        text: btn,
        handler: () => {
          this.openAppstoreEntry()
        }
      })
    }

    if (allowCloser) {
      buttons.push({
        text: 'Close',
        role: 'cancel'
      });
    }

    const alert = await this.alertCtrl.create({
      header,
      message,
      buttons,
      backdropDismiss: allowCloser
    });
    await alert.present();
  }

  async getUpdateFromDB() {
    try {
      return await this.http.get<any>('https://us-central1-ibroker-states.cloudfunctions.net/get_app_information').toPromise();
    } catch (e) {
      throw (e);
    }
  }

}
